module.exports = require("@splunk/ui-utils/i18n");